var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.676v26.918a.406.406 0 0 0 .608.352l2.564-1.472a.775.775 0 0 0 .39-.673V8.846a.677.677 0 0 1 1.014-.586l7.147 4.125a.675.675 0 0 1 0 1.172l-6.04 3.487a.676.676 0 0 0-.338.586v2.55a.677.677 0 0 0 1.015.585l12.485-7.208a.676.676 0 0 0 0-1.172L7.015 2.091A.677.677 0 0 0 6 2.677zm14.266 20.332a.498.498 0 0 1 0-.862l4.333-2.502a1.17 1.17 0 0 0 .583-1.013v-1.866a.84.84 0 0 0-1.26-.728l-10.07 5.813a.84.84 0 0 0 0 1.455l10.07 5.813a.84.84 0 0 0 1.26-.728v-1.868a1.17 1.17 0 0 0-.584-1.012l-4.334-2.502zm-3.99 4.374a2.618 2.618 0 1 1-5.234 0 2.618 2.618 0 0 1 5.235 0z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhl);
export default __webpack_public_path__ + "static/media/PHL.161a3599a48b980585f1227d2a79a9a9.svg";
export { ForwardRef as ReactComponent };